/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
                // JavaScript to be fired on all pages
                var map = new google.maps.Map(document.getElementById('map'), {
                  center: {lat: 53.501315, lng: -2.195469},
                  zoom: 12,
                  styles: [
        		    {
        		        "stylers": [
        		            {
        		                "visibility": "on"
        		            },
        		            {
        		                "saturation": -100
        		            },
        		            {
        		                "gamma": 0.54
        		            }
        		        ]
        		    },
        		    {
        		        "featureType": "road",
        		        "elementType": "labels.icon",
        		        "stylers": [
        		            {
        		                "visibility": "off"
        		            }
        		        ]
        		    },
        		    {
        		        "featureType": "water",
        		        "stylers": [
        		            {
        		                "color": "#4d4946"
        		            }
        		        ]
        		    },
        		    {
        		        "featureType": "poi",
        		        "elementType": "labels.icon",
        		        "stylers": [
        		            {
        		                "visibility": "off"
        		            }
        		        ]
        		    },
        		    {
        		        "featureType": "poi",
        		        "elementType": "labels.text",
        		        "stylers": [
        		            {
        		                "visibility": "simplified"
        		            }
        		        ]
        		    },
        		    {
        		        "featureType": "road",
        		        "elementType": "geometry.fill",
        		        "stylers": [
        		            {
        		                "color": "#ffffff"
        		            }
        		        ]
        		    },
        		    {
        		        "featureType": "road.local",
        		        "elementType": "labels.text",
        		        "stylers": [
        		            {
        		                "visibility": "simplified"
        		            }
        		        ]
        		    },
        		    {
        		        "featureType": "water",
        		        "elementType": "labels.text.fill",
        		        "stylers": [
        		            {
        		                "color": "#ffffff"
        		            }
        		        ]
        		    },
        		    {
        		        "featureType": "transit.line",
        		        "elementType": "geometry",
        		        "stylers": [
        		            {
        		                "gamma": 0.48
        		            }
        		        ]
        		    },
        		    {
        		        "featureType": "transit.station",
        		        "elementType": "labels.icon",
        		        "stylers": [
        		            {
        		                "visibility": "off"
        		            }
        		        ]
        		    },
        		    {
        		        "featureType": "road",
        		        "elementType": "geometry.stroke",
        		        "stylers": [
        		            {
        		                "gamma": 7.18
        		            }
        		        ]
        		    }
        		]
                });
        		var marker = new google.maps.Marker({
        		          position: {lat: 53.501315, lng: -2.195469},
        		          map: map,
        		          title: 'Naked Production Studios'
        		        });
              },

      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },

    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

(function($) {
$(document).ajaxComplete(function() {
	setTimeout(
	function()
	{
	$('.wpcf7-response-output').slideUp('slow');
	}, 1000);
});
})(jQuery);

document.addEventListener("touchstart", function(){}, true);

jQuery(function($) {

$('a[href^="#"]').live('click',function(event){
    event.preventDefault();
    var target_offset = $(this.hash).offset() ? $(this.hash).offset().top : 0;
    //change this number to create the additional off set
    var customoffset = 85;
    $('html, body').animate({scrollTop:target_offset - customoffset}, 500);
});

}(jQuery));
